<template>
    <div class="modal fade" id="classPauseModal" tabindex="-1" aria-labelledby="classPauseModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">Intervalo</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="d-flex flex-column flex-center flex-column-fluid">
                        <div class="d-flex flex-column flex-center text-center">
                            <h1
                                class="fw-bolder text-gray-900"
                                style="font-size: 30px">
                                Intervalo <i class="fa-solid fa-pause fa-lg"></i>
                            </h1>

                            <div class="fw-bolder fs-3 text-gray-500 mb-3">
                                <p>O seu instrutor(a) iniciou o intervalo, não serão feitas solicitações para fazer biometrias nesse período.</p>
                            </div>

                            <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed p-3">
                                <div class="d-flex flex-stack flex-grow-1">
                                    <div class="fw-semibold">
                                        <h4 class="text-gray-900 fw-bold py-2 text-center">
                                            Fique atento(a) ao horário de retorno informado.
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">Entendi!</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, watch } from 'vue';

    const props = defineProps({
        class_paused: {type: Boolean, required: true}
    })

    let modal: any = null;

    onMounted(() => {
        //@ts-ignore
        modal = new bootstrap.Modal('#classPauseModal');

        watch(() => props.class_paused, (value) => {
            if(value) {
                modal.show()
            }
            else {
                modal.hide()
            }
        }, {immediate: true})
    })
</script>
